import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ExternalLink } from 'lucide-react';

const SURVEY_LABELS = {
  ops: { label: 'OPS – Observación de Seguridad', color: '#4A9EFF', emoji: '🛡️' },
  liderazgo: { label: 'Liderazgo en Seguridad', color: '#00C853', emoji: '👥' },
  near_misses: { label: 'Near Miss / Cuasi-Accidente', color: '#FF6B35', emoji: '⚠️' },
};

export default function SurveyModal({ type, url, onClose }) {
  if (!type || !url) return null;
  const info = SURVEY_LABELS[type] || { label: 'Survey', color: '#4A9EFF', emoji: '📝' };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        style={{ background: 'rgba(6,21,46,0.92)', backdropFilter: 'blur(12px)' }}
        onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <motion.div
          initial={{ scale: 0.92, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.92, opacity: 0, y: 20 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          className="relative w-full flex flex-col"
          style={{
            maxWidth: 900,
            height: 'min(90vh, 700px)',
            background: 'var(--vz-bg-card)',
            border: `1px solid ${info.color}30`,
            borderRadius: 20,
            boxShadow: `0 30px 80px rgba(0,0,0,0.7), 0 0 0 1px ${info.color}15`,
          }}
        >
          {/* Header */}
          <div
            className="flex items-center justify-between px-5 py-4 flex-shrink-0 rounded-t-[20px]"
            style={{ background: `${info.color}10`, borderBottom: `1px solid ${info.color}20` }}
          >
            <div className="flex items-center gap-3">
              <span className="text-xl">{info.emoji}</span>
              <div>
                <h2 className="font-montserrat font-bold text-base text-white">{info.label}</h2>
                <p className="text-xs" style={{ color: 'var(--vz-text-muted)' }}>Survey123 · ArcGIS</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-opacity hover:opacity-80"
                style={{ background: `${info.color}20`, color: info.color, border: `1px solid ${info.color}30` }}
              >
                <ExternalLink size={11} />
                Abrir en nueva pestaña
              </a>
              <button
                onClick={onClose}
                className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-900/30 transition-colors"
              >
                <X size={16} style={{ color: 'var(--vz-text-secondary)' }} />
              </button>
            </div>
          </div>

          {/* iframe */}
          <div className="flex-1 overflow-hidden rounded-b-[20px]">
            <iframe
              src={url}
              title={info.label}
              className="w-full h-full"
              style={{ border: 'none', background: '#fff' }}
              allow="geolocation"
            />
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
